import styled from "styled-components";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import { StyledDocumentSelectorOptionProps } from "./StyledDocumentSelectorOption.styled";

const StyledDocumentSelectorOption = styled.button<StyledDocumentSelectorOptionProps>`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  border: transparent;
  background: none;
  -webkit-tap-highlight-color: transparent;

  cursor: pointer;
  position: relative;
  flex-basis: 100%;
  gap: 16px;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  box-shadow: ${({ selected, theme }) =>
    selected
      ? `0 0 0 2px ${theme.colors.primary1}`
      : `0 0 0 1px ${theme.colors.base3}`};

  /* radio button */
  &::after {
    content: "";
    position: absolute;
    top: 16px;
    right: 16px;
    width: 18px;
    height: 18px;
    box-sizing: border-box;
    border-radius: 50%;
    border: ${({ selected, theme }) =>
      selected
        ? `${theme.borderWidthRadio} solid ${theme.colors.primary2}`
        : `1px solid ${theme.colors.base3}`};
  }

  &::before {
    content: "";
    position: absolute;
    top: 20px;
    right: 20px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ selected, theme }) =>
      selected ? theme.colors.primary2 : "transparent"};
  }

  .document-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 8px;
  }

  ${ButtonTitle} {
    text-align: left;
  }
`;

export default StyledDocumentSelectorOption;
